import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'reactstrap';
import SearchAlertsTableRow from './SearchAlertsTableRow';
import CommonTable from '../../../common/components/CommonTable';

function SearchAlertsTable({
  data,
  offset,
  changeOffset,
  copyItemHandler,
  editItemHandler,
  setSearchAlertToDelete,
}) {
  const [tableData, setTableData] = useState({ items: [], total: 0 });

  useEffect(() => {
    setTableData({
      items: data?.items,
      total: data?.total,
    });
  }, [data]);

  if (data?.items.length === 0) {
    return (
      <div className="alert-wrapper">
        <Alert color="info" className="mb-0">
          No search alerts found. Create one to get notified about new matching vehicles.
        </Alert>
      </div>
    );
  }
  return (
    <CommonTable
      headerOptions={['Make', 'Model', 'Years', 'Mileage', 'Actions']}
      lastIsActionColumn={true}
      rowComponent={SearchAlertsTableRow}
      rowComponentProps={{
        copyItemHandler,
        editItemHandler,
        setSearchAlertToDelete,
      }}
      data={tableData}
      offset={offset}
      onOffsetChange={changeOffset}
      className="settings-table settings-table--search-alerts"
    />
  );
}

SearchAlertsTable.propTypes = {
  data: PropTypes.object.isRequired,
  offset: PropTypes.number.isRequired,
  changeOffset: PropTypes.func.isRequired,
  setSearchAlertToDelete: PropTypes.func.isRequired,
};

export default SearchAlertsTable;
